module.exports = __webpack_public_path__ + "img/oil-drum.eb43d925.png";